/**
 * referral email action
 *
 * Created by Paul M on 05/02/19
 */

import C from '../constants'

// action to hide/show the loader for the referral process
export const showReferralLoader = data => {
    return {
        type: C.SET_REFERRAL_LOADER,
        payload: data
    }
}

// action to hide/show the loader for the referral process
export const setReferralResponse = data => {
    return {
        type: C.SET_REFERRAL_RESPONSE,
        payload: data
    }
}


/* -----------------------------------------------------------------------------
    ACTIONS CREATORS
----------------------------------------------------------------------------- */


// call the action to send a referral email
// NOTE: this will be picked up by the referral saga (sagas/referral.js)
export const sendReferralRequest = data => {
    return {
        type: C.SEND_REFERRAL,
        payload: data
    }
}



// WEBPACK FOOTER //
// ./src/actions/referralActions.js